import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const CONTENT_COMPLETION_CONFIG = enabledOn(
  PlatformSlug.INBDEBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher
)

export const isContentCompletionAvailable = (slug?: PlatformSlug) => isFeatureAvailable(CONTENT_COMPLETION_CONFIG, slug)
